import React from 'react'

const TelegramIconNew = (props) => (
  <svg
    width={48}
    height={48}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width={48} height={48} rx={24} fill="#0099CD" />
    <path
      d="M33 12.8502L29.2037 35.0009C29.2037 35.0009 28.6725 36.5366 27.2133 35.8001L18.4542 28.0272L18.4136 28.0043C19.5967 26.7747 28.7714 17.2273 29.1724 16.7945C29.7932 16.1243 29.4078 15.7253 28.6871 16.2316L15.1349 26.1924L9.90649 24.1564C9.90649 24.1564 9.08369 23.8176 9.00454 23.0811C8.92434 22.3433 9.93357 21.9443 9.93357 21.9443L31.2482 12.2667C31.2482 12.2667 33 11.3759 33 12.8502Z"
      fill="white"
    />
  </svg>
)
export default TelegramIconNew
